import Stack from "components/common/Stack";
import React from "react";
import Image from "components/common/Image";
import Text from "components/common/Text";
import JarvisButton from "components/JarvisButton";
import { useHistory } from "react-router-dom";

function AlertKycUi() {
  const history = useHistory();
  const items = [
    { src: "/svgs/squarebox.svg", label: "4 Benefits" },
    { src: "/svgs/step.svg", label: "2 Steps" },
    { src: "/svgs/clock.svg", label: "1 Minute" },
    { src: "/svgs/target.svg", label: "1 Goal" },
  ];

  return (
    <Stack>
      <Stack
        direction="row"
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          mt: 6,
          mb: 4,
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        <Stack sx={{ ml: 2 }}>
          <Stack sx={{ mb: 3 }}>
            {/* aadhar log and text */}
            <Stack
              direction="row"
              spacing={2}
              sx={{
                mb: 0,
                flexDirection: { xs: "column", md: "row" },
                justifyContent: { xs: "center", md: "flex-start" },
                alignItems: { xs: "center", md: "flex-start" },
              }}
            >
              <Image src="/svgs/aadhaar.svg" width={60} />
              <Text variant="h3">
                Complete Your <span style={{ color: "#90d5ff" }}>Re-KYC</span>{" "}
                Now!
              </Text>
            </Stack>
            <Text
              sx={{ fontSize: { xs: "18px", md: "22px" }, fontWeight: 500 }}
            >
              As the financial year to a close, it's time to update your KYC
              details
            </Text>
          </Stack>
          {/* groups benefits, steps */}
          <Stack
            direction="row"
            sx={{
              mb: 2,
              backgroundColor: "#fff",
              borderRadius: 8,
              padding: "24px",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {items.map((item, index) => (
              <Stack key={index} align="center">
                <Image src={item.src} width={40} />
                <Text>{item.label}</Text>
              </Stack>
            ))}
          </Stack>
          <Text
            sx={{
              fontStyle: "italic",
              fontSize: { xs: 12, md: 18 },
              fontWeight: 400,
            }}
          >
            It only take a minute! Click to complete your KYC and secure your
            account.
          </Text>
        </Stack>
        <Stack spacing={1} sx={{ mr: 3 }}>
          <Image src="/svgs/rekyc.svg" />
          <Text sx={{ fontSize: 13 }}>
            *Complete the KYC before the attempts are exhausted
          </Text>
          <JarvisButton
            disableEndIcon={true}
            sx={{ width: { xs: "100%", md: "auto" } }}
            onClick={() => history.push("/re-kyc")}
          >
            Verify My KYC Now
          </JarvisButton>
        </Stack>
      </Stack>
    </Stack>
  );
}

export default AlertKycUi;
